import React from 'react'

import { Col, Row } from '_zari/core'

import * as Formatos from './formatos'

const ComprasReportes = () => {
  return (
    <Row>
      <Col md={6}>
        <Formatos.FormatoReporteCompras />
      </Col>
      <Col md={6}>
        <Formatos.FormatoCruceComprasContabilidad />
      </Col>
      <Col md={6}>
        <Formatos.FormatoReporteOrdenes />
      </Col>
    </Row>
  )
}

export default ComprasReportes
